import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BucketNodeSnapshotResponse } from "../../types";

interface BucketNodeState {
	value: BucketNodeSnapshotResponse | undefined
}

const initialState: BucketNodeState = {
	value: undefined
};

export const bucketNodeSlice = createSlice({
	name: 'bucketNodes',
	initialState,
	reducers: {
		set: (state = initialState, action: PayloadAction<BucketNodeSnapshotResponse | undefined>) => {
			state.value = action.payload;
		}
	}
});

export const { set } = bucketNodeSlice.actions;

export default bucketNodeSlice.reducer;
